import React, { Component } from 'react'
import Chart from "react-apexcharts";
import { Card, Col, Row} from "reactstrap";
import { configuration } from "../../src/appConfig";
import Axios from "axios";
import './Statistics.css'
import moment from 'moment';

export class Statistics extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          words: {},
          lang: "",
          day : [],
          weeks : [],
          days_data : [],
          weeks_data : [],
          authorizer_name_array : [],
          authorizer_name : [],
          currentWeek : '',
          formattedDates : [],
          formattedDates_week : [],
          colorMap: {},
          colorMap_day : {},
        }
    }

  componentDidMount() {
    this.getLang();
    this.search();
  }

  formatDate = () => {
    const { day, weeks } = this.state;
    const parsedDate = new Date(day);
    const days = parsedDate.getDate().toString().padStart(2, '0');
    const month = (parsedDate.getMonth() + 1).toString().padStart(2, '0'); // Note: Months are 0-indexed in JavaScript
    const year = parsedDate.getFullYear();

    const formattedDate = `${days}`;
    this.setState((prevState) => ({
      formattedDates: [...prevState.formattedDates, formattedDate],
    }));

    const formattedDates_week = weeks.map((date) => {
      const parsedDate = new Date(date);
      const day = parsedDate.getDate().toString().padStart(2, '0');
      const month = (parsedDate.getMonth() + 1).toString().padStart(2, '0'); // Note: Months are 0-indexed in JavaScript
      const year = parsedDate.getFullYear();

      const formattedDate_week =  `${day}`;
      this.setState((prevState) => ({
        formattedDates_week : [...prevState.formattedDates_week, formattedDate_week],
      }));
    });

  };

  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({ words: res.data, lang: localStorage.getItem("lang") });
    });
  };

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }

  search = () => {
    const partnerId = localStorage.getItem('partnerId')
    const url = `${configuration.getGraphStatistics}?partnerId=${partnerId}`;
    Axios
      .get(url)
      .then((res) => {
        if(res.data){
          this.setState({
            day : res.data.day,
            days_data : res.data.days_data, 
            weeks : res.data.weeks, 
            weeks_data : res.data.weeks_data,
            currentWeek : res.data.currentWeek,
            authorizer_name : Object.keys(res.data.days_data),
            authorizer_name_array : res.data.authorizer_name_array
          },
          () => {
            this.formatDate();
            this.generateColor_Day(this.state.authorizer_name);
            this.generateColor(res.data.authorizer_name_array);
          }
          );
        }else {
          console.error("Response data is undefined or null");
        }
      })
      .catch((err) => {
      });
  
  }

   nearestLargerMultiple = (value, multiple) => {
    if (value % multiple === 0) {
      return value + 5;  
    }
    const remainder = value % multiple;
    const nearestLargerMultiple = value - remainder + 5;
    return nearestLargerMultiple;
  }
  getOption = () => {
    const { colorMap_day, days_data } = this.state;
    const values = colorMap_day && Object.values(colorMap_day);
    let daysCount = Math.max(...Object.values(days_data));
  
    const tickCount = 5; // Adjust the number of ticks as needed
  
    return {
      id: "Day_chart",
      chart: {
        type: "bar",
        toolbar: {
          show: true,
          tools: {
            download: false
          }
        }
      },
      xaxis: {
        type: "name",
        categories: Object.keys(days_data),
        labels: {
          style: {
            fontSize: '15px',
            fontWeight: 600,
          },
        },
      },
      yaxis: [
        {
          min: 0,
          max: this.nearestLargerMultiple(daysCount, tickCount),
          title: {
            text: this.lang("Authorized"),
            style: {
              fontSize: '18px',
              fontWeight: '600',
              color: "#0b0c0d",
            },
          },
          tickAmount: tickCount, // Set the tickAmount option here
        },
      ],
      title: {
        text: this.lang("Today"),
        align: 'center',
      },
      stroke: {
        colors: ["transparent"],
        width: 10
      },
      plotOptions: {
        bar: {
          // columnWidth: '20px',
          endingShape: "rounded",
          horizontal: false,
          dataLabels: {
            position: 'top',
          },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val;
        },
        offsetY: -30,
        style: {
          fontSize: '18px',
          colors: ["#304758"]
        }
      },
      // Other options...
    };
  }
  
  getSeries = () => {
    const { colorMap_day, days_data } = this.state;
    const values = colorMap_day && Object.values(colorMap_day);
    let emptyarr = [];
    let series = [];
    Object.entries(days_data).map((name, i)=>{
      let  daysdata = {
        x : name[0],
        y : name[1],
        fillColor : values[i]
      }
      emptyarr.push(daysdata)
    })
    series.push({
      name : "value",
      data : emptyarr
    })
    return series
  };

  getOption_week = () => {
    const { colorMap, weeks_data } = this.state;
    const values = colorMap && Object.values(colorMap);
    let maxvalue = -Infinity;
    for (const date in weeks_data) {
      const dateData = weeks_data[date]; 
      for (const key in dateData) {
        if (dateData[key] > maxvalue) {
          maxvalue = dateData[key];
        }
      }
    }

    const tickCount = 5; // Adjust the number of ticks as needed
    return {
      id: "Week_chart", 
      chart: {
        type: "bar",
        toolbar: {
          show: true,
          tools: {
            download: false
          }
        }
      },
      plotOptions: {
        bar: {
          columnWidth: '85%',
          endingShape: "rounded",
          horizontal: false,
          dataLabels: {
            position: 'top',
            enabled: true,
          },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val;
        },
        offsetY: -30,
        style: {
          fontSize: '15px',
          colors: ["#304758"]
        }
      },
      stroke: {
        colors: ["transparent"],
        width: 2
      },
      xaxis: {
        type: "Category",
        categories: this.state.formattedDates_week,
        labels: {
          show: true,
          style: {
            fontSize: '15px', 
            fontWeight: 600,
          },
        },
      },
      legend: {
        show: true,
        showForSingleSeries: true,
      },
      yaxis: [
        {
          min: 0,
          // max: maxCount,
          max: this.nearestLargerMultiple(maxvalue, tickCount),
          title: {
            text: this.lang("Authorized"),
            style: {
              fontSize: '18px',
              fontWeight : '600',
              color: "#0b0c0d"
            },
          },
          tickAmount: tickCount, // Set the tickAmount option here
        },
      ],
      title: {
        text: this.lang("This Week"),
        align: 'center',
      },
      colors: values,
    };
  }

  getSeries_week = () => {
    const { weeks_data } = this.state;
    const dates = Object.keys(weeks_data);
    const allNames = new Set();
    const seriesData = [];
 
    dates.forEach((date) => {
      const dateData = weeks_data[date];
       Object.keys(dateData).forEach((name) => {
        if (dateData[name] !== undefined && dateData[name] !== null) {
          allNames.add(name);
        }
      });
    });
    
    Array.from(allNames).forEach((name) => {
        const dataPoints = dates.map((date) => weeks_data[date][name] || 0);

        seriesData.push({
          name,
          data: dataPoints,
        });
    });
    return seriesData;
  };

  generateColor = (name) => {
    if (name && Array.isArray(name)) {
      let colorMap = {};
      const colorname = ["#5B9BD5", "#ED7D31" ,"#A5A5A5" , "#FFC000" ,"#206B9E" , "#DA4AB1" , "#EEA591" ,"#7E39BE" , "#35DCDB",
      "#AC81A1", "#B9C2FD" ,"#82DEF4" , "#22ACA0" ,"#AFA0E7" , "#FAC59A" , "#6F89C3" ,"#747379" , "#F2D4CD"];
  
      name.forEach((authorizerName, index) => {
        if (index < colorname.length) {
          colorMap[authorizerName] = colorname[index];
        } else {
          const colorIndex = index % colorname.length;
          colorMap[authorizerName] = colorname[colorIndex];
        }
      });
  
      this.setState({ colorMap },
        () => {
          this.generateColor_Day();
        }
        );
    } else {
      console.error("Authorizer names are undefined, null, or not an array");
    }
  };

  generateColor_Day = () => {
    const { authorizer_name, colorMap } = this.state;
    let colorMap_day = {};
  
    authorizer_name.forEach((name, index) => {
      if(Object.keys(colorMap).length && colorMap.hasOwnProperty(name)){
        colorMap_day[name] = colorMap[name]
      }
    });
    this.setState({ colorMap_day });
  };

 
  render() {
    return (
        <>
        <div className='Container'>
        <Row>
            <Col>
              <Card className="Statistics_main pt-2">
                <div className='row'>
                    <div className='col-lg-12 col-md-12 col-sm-12 mb-3' id='Day_chart'>
                        <Chart options={this.getOption()} series={this.getSeries()} type="bar" height={'380px'} />
                    </div>
                </div>
              </Card>
            </Col>
        </Row>
        <Row>
            <Col>
              <Card className="Statistics_main pt-2">
                <div className='row'>
                    <div className='col-lg-12 col-md-12 col-sm-12' id='Week_chart'>
                        <Chart options={this.getOption_week()} series={this.getSeries_week()} type="bar" height={'380px'}/>
                    </div>
                </div>
              </Card>
            </Col>
        </Row>
            
        </div>
      </>
    )
  }
}

export default Statistics

